var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#EC5569"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.5,
    y: 5,
    width: 22,
    height: 19.9893
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_14866_3964_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4,
    d: "M14.8594 10.8916C16.3062 9.39584 17.8345 9.2559 18.9746 9.77441C20.1454 10.3071 21 11.5715 21 13.0762C21 14.6123 20.3679 15.7967 19.4629 16.8105C18.5408 17.8435 17.3779 18.658 16.3184 19.4883L16.3174 19.4893C15.9499 19.7781 15.6199 20.0328 15.3018 20.2178C14.9835 20.4028 14.7237 20.4893 14.5 20.4893C14.2764 20.4893 14.0166 20.4028 13.6982 20.2178C13.5391 20.1252 13.3772 20.0144 13.209 19.8916L12.6816 19.4893C11.6222 18.6581 10.4593 17.8436 9.53711 16.8105C8.63202 15.7966 8 14.6117 8 13.0752C8.00015 11.5705 8.85466 10.3059 10.0254 9.77344C11.1655 9.25501 12.6938 9.39549 14.1406 10.8916L14.5 11.2637L14.8594 10.8916Z",
    fill: "#EC5569",
    stroke: "#EC5569"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_14866_3964_clip_path",
    transform: "translate(-3.5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8594 10.8916C16.3062 9.39584 17.8345 9.2559 18.9746 9.77441C20.1454 10.3071 21 11.5715 21 13.0762C21 14.6123 20.3679 15.7967 19.4629 16.8105C18.5408 17.8435 17.3779 18.658 16.3184 19.4883L16.3174 19.4893C15.9499 19.7781 15.6199 20.0328 15.3018 20.2178C14.9835 20.4028 14.7237 20.4893 14.5 20.4893C14.2764 20.4893 14.0166 20.4028 13.6982 20.2178C13.5391 20.1252 13.3772 20.0144 13.209 19.8916L12.6816 19.4893C11.6222 18.6581 10.4593 17.8436 9.53711 16.8105C8.63202 15.7966 8 14.6117 8 13.0752C8.00015 11.5705 8.85466 10.3059 10.0254 9.77344C11.1655 9.25501 12.6938 9.39549 14.1406 10.8916L14.5 11.2637L14.8594 10.8916Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartActive);
export default __webpack_public_path__ + "static/media/icon_heart_active.6b1b3bb0deded4749cf0fd2782df3638.svg";
export { ForwardRef as ReactComponent };